<template>
  <div class="">
    <b-row>
      <b-col lg="4" md="6" sm="6">
        <b-row>
          <b-col lg="4" md="4" sm="6" v-if="showone == 'IndirectIssue'">
            <div class="field">
              <label>{{ $t("Request.requestid") }}</label>
              <p class="common-heading">{{ requstvalues.requestId }}</p>

            </div>
          </b-col>
          <b-col lg="4" md="4" sm="6" v-if="showone == 'DirectIssue'">
            <div class=" field">
              <label>{{ $t("issue.issueid") }}</label>
              <p class="common-heading">{{ requstvalues.issueId }}</p>

            </div>
          </b-col>
          <b-col lg="4" md="4" sm="6" v-if="showone == 'salesorderissue'">
            <div class=" field">
              <label>{{ $t("issue.issueid") }}</label>
              <p class="common-heading">{{ requstvalues.issueId }}</p>
            </div>
          </b-col>
          <b-col lg="4" md="4" sm="6" v-if="showone == 'IssueReturn'">
            <div class="field">
              <label>{{ $t("issue.issuereturnid") }}</label>
              <p class="common-heading">{{ requstvalues.issueReturnId }}</p>

            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="4" sm="6" class="d-flex mt-3">
        <div class="location-line position-relative ms-3 w-100">
          <b-row class="">
            <b-col class="">
              <p class="light-txt mt-4">{{ storeDetails.fromStoreCode }}</p>
              <p class="light-txt">{{ storeDetails.fromStoreName }}</p>
              <img class="location-icon1" src="../../../../../assets/Img/icons/location.svg" />
            </b-col>
            <b-col class="d-flex flex-direction-column align-items-end">
              <img class="location-icon2" src="../../../../../assets/Img/icons/location.svg" />
              <p class="light-txt mt-4">{{ storeDetails.toStoreCode }}</p>
              <p class="light-txt">{{ storeDetails.toStoreName }}</p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="6">
        <div class="field">
          <TextArea v-model="remarks.Remarks" :required-icon="false" name="Remarks" id="Remarks"
            :label="$t('issue.remarks')" :rules="{ required: false }" :disabled="false" :rows="3" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  reactive,
  watch,
  nextTick,
  watchEffect,
} from "vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import Dropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import TextArea from "../../../../../components/FormComponents/TextArea.vue";
// import common from "../../../../../modules/Inventory/Service/CommonService";
import { value } from "dom7";

export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
    storeDetails: {
      type: Object,
      default: () => ({}),
    },
    value: {},
  },

  components: {
    TextField,
    Dropdown,
    Datepicker,
    TextArea,
  },
  setup(props, { emit }) {
    debugger;

    let requstvalues = reactive({
      requestId: "",
      fromStoreId: 0,
      fromStoreName: "",
      toStoreId: 0,
      toStoreName: "",
      issueId: "",
      issueReturnId: "",
      fromStoreCode: "",
      toStoreCode: "",
    });
    let remarks = reactive({
      Remarks: "",
    });
    function remarksvalue() {
      debugger;
      emit("update:modelValue", remarks);
    }
    console.log("Received message56:", props.storeDetails);
    onMounted(() => {
      debugger;
      Object.assign(requstvalues, props.storeDetails);
      Object.assign(remarks, props.storeDetails);
      remarksvalue();
    });

    watch(
      props,
      (newValue) => {
        debugger;
        Object.assign(requstvalues, newValue.storeDetails);
        Object.assign(remarks, newValue.storeDetails);
      },
      { deep: true, immediate: true }
    );

    return {
      requstvalues,
      remarks,
      remarksvalue,
    };
  },
});
</script>
